<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="story"><a id="page_1"></a>CHANGE THE STORY, CHANGE THE FUTURE</h2>
<p class="noindent"><strong>Choice-making beings of many possibilities, we humans live by shared cultural stories. They are the lens through which we view reality. They shape what we most value as a society and the institutions by which we structure power.</strong></p>
<p class="indent"><strong>When we get our story wrong, we get our future wrong.</strong></p>
<p class="indent"><strong>We are in terminal crisis because we have our defining story badly wrong. Seduced by a fabricated Sacred Money and Markets story, we live in indentured service to money-seeking corporate robots and relate to Earth as if it were a dead rock for sale.</strong></p>
<p class="indent"><strong>Communications technologies now give us the capacity as a species to choose our common story with conscious intention. This is a moment of unprecedented opportunity to create a future consistent with our true nature and possibility as living beings born of a Living Earth born of a Living Universe.</strong></p>
<p class="indent"><strong>An authentic Sacred Life and Living Earth story is emerging. It has ancient roots in indigenous wisdom. If embraced, it changes everything.</strong></p>
<p class="indent"><strong>Change the story, change the future.</strong><a id="page_2"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// story.vue?7f8e201c